<template>
  <section class="contact">
    <div class="container">
      <h1>What can we do for you?</h1>
      <p class="contact-note">Tell us a bit about your project — we usually reply within one business day.</p>
      <form 
        id="contact-form"
        @submit.prevent="processForm"
      >
        <div class="form-group">
          <label for="name">What’s your name? <span class="highlight">*</span></label>
          <input id="name" type="text" name="name" v-model="name" required>
        </div>
        <div class="form-group">
          <label for="email">An email to reach you <span class="highlight">*</span></label>
          <input id="email" type="email" name="email" v-model="email" required>
        </div>
        <div class="form-group">
          <label for="phone">How about a phone number?</label>
          <input id="phone" type="tel" name="phone" v-model="phone">
        </div>
        <div class="form-group extra-field" aria-hidden="true">
          <label for="website">Leave this field empty</label>
          <input id="website" type="text" name="website" v-model="website" tabindex="-1" autocomplete="off">
        </div>
        <div class="form-group">
          <h4>What do you need help with?</h4>
          <div class="checkbox-form-group">
            <label>
              Website
              <input type="checkbox" name="services[]" value="Website" v-model="services">
              <span class="checkmark"></span>
            </label>
            <label>
              IOS/Android App
              <input type="checkbox" name="services[]" value="IOS/Android App" v-model="services">
              <span class="checkmark"></span>
            </label>
            <label>
              Backend/Web Services
              <input type="checkbox" name="services[]" value="Backend/Web Services" v-model="services">
              <span class="checkmark"></span>
            </label>
            <label>
              Marketing
              <input type="checkbox" name="services[]" value="Marketing" v-model="services">
              <span class="checkmark"></span>
            </label>
            <label>
              Consultation
              <input type="checkbox" name="services[]" value="Consultation" v-model="services">
              <span class="checkmark"></span>
            </label>
            <label>
              Other
              <input type="checkbox" name="services[]" value="Other" v-model="services">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div class="form-group">
          <label for="message">Have a message?</label>
          <textarea id="message" type="text" name="message" rows="6" v-model="message">
          </textarea>
        </div>
        <button type="submit" class="submit-btn" :disabled="submitting">Submit</button>
        <p v-if="submitFailed" class="form-error" role="alert">
          Something went wrong sending your message. Please try again, or email us
          directly at <a href="mailto:apps@biscuitandchai.com">apps@biscuitandchai.com</a>.
        </p>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      name: null,
      email: null,
      phone: null,
      message: null,
      services: [],
      website: '',
      loadedAt: null,
      submitting: false,
      submitFailed: false,
    }
  },
  mounted() {
    this.loadedAt = Date.now()
  },
  methods: {
    processForm() {
      // Bots fill the hidden field or submit faster than a human can type.
      // Pretend success so they don't learn to adapt.
      if (this.website || Date.now() - this.loadedAt < 3000) {
        window.location.href = '/thank-you'
        return
      }
      if (this.submitting) {
        return
      }
      this.submitting = true
      this.submitFailed = false
      const submitURL = 'https://biscuitandchai.com/api/contactform'
      const postData = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        message: this.message,
        helpTech: this.services,
      }
      const formOptions = {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
      fetch(submitURL, formOptions)
        .then(response => {
          if (response.ok) {
            window.location.href = '/thank-you'
          } else {
            this.submitting = false
            this.submitFailed = true
          }
        })
        .catch(error => {
          this.submitting = false
          this.submitFailed = true
          console.error(error)
      })
    },
  },
}
</script>
